import { render, staticRenderFns } from "./PhotographyExternalSection.vue?vue&type=template&id=cfa2bc86"
import script from "./PhotographyExternalSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyExternalSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyExternalSection.vue?vue&type=style&index=0&id=cfa2bc86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports